import { Typography } from "@mui/material"
import { format, parse, parseISO } from "date-fns"
import { enqueueSnackbar, VariantType } from "notistack"

export const getValueText = (value: number | string) => {
  if (typeof value === "string") {
    return value
  }
  return value > 999999 ? `${(value / 1000000).toFixed(1)}M` : value > 999 ? `${(value / 1000).toFixed(1)}K` : value
}

export const getFilterText = (filter: any) => {
  if (!filter) return ""
  const stringifiedFilters = Object.keys(filter).map(
    (key, idx) => `${key}=${filter[key]}${Object.keys(filter).length - 1 === idx ? "" : "&"}`
  )
  let endString = ""
  for (const filterString of stringifiedFilters) {
    endString = endString.concat(filterString)
  }
  return `&${endString}`
}

export const getDate = (date: string) => {
  try {
    return format(parse(date, "yyyy-LL-dd", new Date()), "dd/LL/yyyy")
  } catch (e) {
    try {
      return format(parseISO(date), "dd/LL/yyyy")
    } catch (e) {
      return date
    }
  }
}

export function encodeData(token: string, expirationMinutes: number) {
  const now = new Date()
  const expirationSeconds = expirationMinutes * 60000
  const expirationDate = new Date(now.getTime() + expirationSeconds)

  const data = {
    token,
    date: expirationDate.toISOString()
  }

  const jsonString = JSON.stringify(data)
  const encodedString = btoa(jsonString)

  return encodedString
}

export function decodeData(encodedString: any) {
  try {
    const jsonString = atob(encodedString)
    const data = JSON.parse(jsonString)

    const now = new Date()
    const expirationDate = new Date(data.date)

    if (now > expirationDate) {
      return { expired: true, token: null }
    }

    return { expired: false, token: data.token }
  } catch (error) {
    return { expired: true, token: null }
  }
}

export const addCommasToNumber = (numberString: string): string => {
  const parts: string[] = []
  const startIndex = numberString.length % 3 || 3
  parts.push(numberString.slice(0, startIndex))

  for (let i = startIndex; i < numberString.length; i += 3) {
    parts.push(numberString.slice(i, i + 3))
  }

  return parts.join(",")
}

export const getArtistCode = (artistCode?: string) => {
  return artistCode || localStorage.getItem("artistCode") || "funding"
}

export const getArtistId = () => {
  return localStorage.getItem("offersArtistId") || ""
}

export const toastMessage = (message: string, variant: VariantType, autoHideDuration?: number) => {
  enqueueSnackbar(message, {
    variant,
    anchorOrigin: { vertical: "top", horizontal: "right" },
    autoHideDuration: autoHideDuration || 2000,
    style: {
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500
    }
  })
}

export const getCurrency = (currency: string) => {
  if (currency === "EUR") return "€"
  else if (currency === "TRY") return "₺"
  else if (currency === "USD") return "$"
  else if (currency === "GBP") return "£"
  else if (currency === "DKK") return "kr."
  else if (currency === "JPY") return "¥"
  else if (currency === "SEK") return "kr"
  else if (currency === "INR") return "₹"
  else if (currency === "RUB") return "₽"

  return currency
}

export const formatNumberComma = (text: string) => {
  if (!text) {
    return ""
  }
  const numericValue = text.replace(/\D/g, "")
  return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const calculateSize = (
  screenWidth: number,
  screenHeight: number,
  isMobile: boolean,
  minSize: number,
  noShrink?: boolean
) => {
  const baseWidth = 1600
  let calculatedMinSize = minSize + 2
  if (screenHeight < 800 && screenWidth < 400) {
    calculatedMinSize = minSize
  }
  if (screenWidth < 300 && !noShrink && minSize - 3 > 0) {
    calculatedMinSize = minSize - 3
  }
  const size = calculatedMinSize * (screenWidth / baseWidth)
  return Math.max(calculatedMinSize, Math.round(size))
}

export const checkMobile = () => {
  if (typeof navigator === "undefined") return false
  const ua = navigator.userAgent
  const mobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua)
  return mobile
}
